import React from 'react';
import PropTypes from 'prop-types';

import { gettext } from 'utils/text';
import reverseUrl from 'utils/urls';

const ArenaUploadNewMediaItem = ({ extraQueryParams }) => {
    const extraGetParamsString =
        extraQueryParams === {}
            ? ''
            : '?' +
              Object.entries(extraQueryParams)
                  .map(([key, value]) => `${key}=${value}`)
                  .join('&');
    return (
        <div className="arena__item">
            <div className="arena__item__upload">
                <div className="m-3">{gettext('You can upload new artwork to use it here')}</div>
                <a href={reverseUrl('trafo_arena_media_add') + extraGetParamsString} className="btn btn-primary m-3">
                    {gettext('Upload')}
                </a>
            </div>
        </div>
    );
};

ArenaUploadNewMediaItem.propTypes = {
    extraQueryParams: PropTypes.objectOf(PropTypes.string),
};

ArenaUploadNewMediaItem.defaultProps = {
    extraQueryParams: {},
};

export default ArenaUploadNewMediaItem;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaUploadNewMediaItem.js